import { render, staticRenderFns } from "./create-shipment.vue?vue&type=template&id=529ba3b2&scoped=true"
import script from "./create-shipment.vue?vue&type=script&lang=js"
export * from "./create-shipment.vue?vue&type=script&lang=js"
import style0 from "./create-shipment.vue?vue&type=style&index=0&id=529ba3b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529ba3b2",
  null
  
)

export default component.exports